<div class="jumbotron mt-5">
  <h1 class="display-4">Welcome to the SE PR group phase!</h1>
  <hr class="my-4">
  @if (!authService.isLoggedIn()) {
    <a class="btn btn-primary btn-lg" routerLink="/login" role="button">Login</a>
  }
  @if (authService.isLoggedIn()) {
    <div>
      <p>Check out the latest message from the SE PR group phase.</p>
      <p class="lead">
        <a class="btn btn-primary btn-lg" routerLink="/message" role="button">Message</a>
      </p>
    </div>
  }
</div>
